
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { FormattedMessage } from "react-intl";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../../Utils/layout";
import "../../../../Utils/_assets/sass/login.scss";
import "../../../../Utils/_assets/sass/pages/login/classic/login-1.scss";
import { toAbsoluteUrl } from "../../../../Utils/_helpers";
import { APP_CONSTANT, APP_INFOGRAPICS } from "../../../util/constants";
import { isMobile } from "../../../util/helpers";
import ForgotPassword from "./ForgotPassword";
import Login from "./Login";
import Registration from "./Registration";
import ResetPassword from "./ResetPassword";
import AutoLogin from '../../../util/AutoLogin';

export function AuthPage() {
  const [loading, setLoading] = useState(false);
  const [autoLogin, setAutoLogin] = useState(false);

  const checkMobile = () => {
    if (isMobile === true) {
    }
  };

  if (!loading) {
    checkMobile();
    setLoading(true);
  }

useEffect(() => {
  if(window.location.pathname == '/ssologin') setAutoLogin(true);
}, [window.location])

  return (
    <>
      <div className="d-flex flex-column flex-root theme-bg">
        {/*begin::Login*/}
        {autoLogin &&
          <Switch>
            <ContentRoute path="/ssologin" component={AutoLogin} />
            <Redirect to="/login" />
          </Switch>
        }
        {!autoLogin && <div
          className="login login-1 login-signin-on sr-auth-container container1"
          id="kt_login"
        >
          <div className="row">
            <div className="col-5 d-block d-lg-none">
              <div className="login-hdr-left">
                <img
                  alt=""
                  src={toAbsoluteUrl("/media/sr/logos/main-logo.svg")}
                  className="main-logo"
                />
              </div>
            </div>
            <div className="col-7">
              <div className="help-txt d-none d-lg-block">
                <span className="help-issue-txt">
                  <FormattedMessage
                    id="having-issues"
                    defaultMessage="Having issues?"
                  />
                </span>
                &nbsp;
                <a
                  target="_blank"
                  href="http://support.knowlarity.com/support/home"
                  className="link-clr "
                  id="kt_login_signup"
                  rel="noreferrer"
                >
                  <FormattedMessage id="get-help" defaultMessage="Get Help" />
                </a>
              </div>
              <div className="help-txt d-block d-lg-none">
                <div className="help-issue-txt">
                  <FormattedMessage
                    id="having-issues"
                    defaultMessage="Having issues?"
                  />
                </div>
                <div>
                  <a
                    target="_blank"
                    href="http://support.knowlarity.com/support/home"
                    className="link-clr "
                    id="kt_login_signup"
                    rel="noreferrer"
                  >
                    <FormattedMessage id="get-help" defaultMessage="Get Help" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-7 d-none d-lg-block">
              <div className="login-carousel mt-1">
                <Carousel controls={false}>
                  {APP_INFOGRAPICS.map((citem) => (
                    <Carousel.Item interval={300} key={citem.id}>
                      <img
                        className="d-block caro-img"
                        src={toAbsoluteUrl(citem.image)}
                        alt={citem.title}
                      />
                      <a
                        className={"ga_link"}
                        href={citem.redirect_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Carousel.Caption>
                          <h3 className="main-title">
                            <FormattedMessage
                              id={citem.title}
                              defaultMessage="Title"
                            />
                          </h3>
                          <p className="sub-title">
                            <FormattedMessage
                              id={citem.sub_title}
                              defaultMessage="Sub Title"
                            />
                          </p>
                        </Carousel.Caption>
                      </a>
                      <div className="lets-cnt">
                        <a
                          rel="noreferrer"
                          target="_blank"
                          href={citem.redirect_url}
                          className="link-clr"
                          id="kt_login_signup"
                        >
                          <FormattedMessage
                            id="Auth_general-free-trial2"
                            defaultMessage="Let’s Connect to Know More"
                          />
                          &nbsp;&nbsp;
                          <img
                            alt=""
                            src={toAbsoluteUrl(
                              "/media/sr/icons/right-arrow.svg"
                            )}
                            className="right-icon"
                          />
                        </a>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </div>
            <div className="col-lg-5 col-md-12">
              <div className="auth-form-container">
                <div className="d-flex flex-column-fluid flex-center mt-0">
                  <Switch>
                    <ContentRoute path="/ssologin" component={AutoLogin} />
                    <ContentRoute path="/auth/login22" component={Login} />
                    <ContentRoute path="/login" component={Login} />
                    <ContentRoute
                      path="/auth/registration"
                      component={Registration}
                    />
                    <ContentRoute
                      path="/forgotPassword"
                      component={ForgotPassword}
                    />
                    <ContentRoute
                      path="/resetPassword"
                      component={ResetPassword}
                    />
                    <Redirect from="/auth" exact={true} to="/login" />
                    <Redirect to="/login" />
                  </Switch>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 d-none d-lg-block">
              <div className="site-footer m-10 text-center">
                Copyright &#169; {APP_CONSTANT.COPYRIGHT_YEAR}, Knowlarity
                Communications Pvt. Ltd | Powered by Knowlarity | &nbsp;
                <a
                  href={APP_CONSTANT.SR_POLICY_LINK}
                  target="_blank"
                  className="link-clr"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>{" "}
                | &nbsp;
                <a
                  href={APP_CONSTANT.SR_TERMS_LINK}
                  target="_blank"
                  className="link-clr"
                  rel="noreferrer"
                >
                  Terms &amp; Conditions
                </a>
              </div>
            </div>
          </div>
        </div>}
      </div>
    </>
  );
}
